import { useEffect, useState } from 'react';
import { Maybe } from '../types';

export default function usePromiseWaiting<T>(fn: () => Promise<T> | null, deps: any[]) {
  const [result, setResult] = useState<Maybe<T>>(null);
  const [error, setError] = useState<Maybe<Error>>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const promise = fn();
    if (promise === null) return;
    promise.then((value) => setResult(value))
      .catch(setError)
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return [loading, result, error] as const;
}
